// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"356":"jobstructure","765":"newproject"}[chunkId] + "." + {"356":"7417b322","765":"fc312e4c"}[chunkId] + ".js";
};